import {getCookie} from '../app.js';
import {autosize} from "../app.js";

class LearnerComments extends HTMLElement {
    constructor() {
        // Always call super first in the constructor
        super();
    }

    // Specify observed attributes for watching
    static get observedAttributes() {
        return ['id', 'json'];
    }

    // Lifecycle method called when the custom element is first connected to the document's DOM.
    connectedCallback() {
        var websiteurl = getCookie('WEBSITE_URL');
        const c_websiteurl = websiteurl;
        const c_id = this.id;

        function safeParse(data) {
            if (typeof data === 'string') { try { return JSON.parse(data); } catch(e) { return data; } }
            return data;
        }

        this.innerHTML = "<h3 id='learner-heading' style='display:none'></h3>" +
            "" +
            "  <input type='hidden' name='id' value='" + this.id + "'>" +
            "  <div class=\"panel-group\" id=\"accordion\">" +
            "    <div class=\"panel panel-default comments-panel\" style='background: #eaeaea !important;'>" +
            "      <div id=\"collapse4\" class=\"panel-collapse in\">" +
            "        <div class=\"panel-body\">" +
        "               <div id='qas-container' style='display: none; font-size: 12px; margin-bottom: 40px;'>" +
            "               <h4 class=\"box-title\"><img src=\"/img/tabler/help-circle.svg\" style=\"width: 20px; position: relative; top: -2px; opacity: 1;\" /> QUESTIONS AND ANSWERS <span style='font-size: 16px; position: relative; top: -2px;' class='badge badge-default' id='qa_score'>0</span>" +
                "            <button id=\"btn-add-new-qa\" type=\"button\" class=\"btn btn-default btn-sm\" data-bs-toggle=\"modal\" data-bs-target=\"#addModal\">Add New Item  <img src=\"/img/tabler/circle-plus.svg\" style=\"height: 14px; width: 14px;\" alt=\"\" /></button>\n" +
                        "</h4>" +
            "          <table id='qasTable' class='table table-striped table-bordered' style='width:100%'>" +
            "            <thead>" +
            "              <tr>" +
            "                <th>Question</th>" +
            "                <th>Answer</th>" +
            "                <th>Score</th>" +
            "                <th style='width: 32px !important;'></th>" +
            "                <th style='width: 32px !important;'></th>" +
            "              </tr>" +
            "            </thead>" +
            "            <tbody></tbody>" +
            "          </table>" +
                        "</div>" +
            "           <h4 class=\"box-title\">COMMENTS <span style='font-size: 16px; position: relative; top: -2px; display: inline;' class='badge badge-default' id='comments_score'>0</span></h4>" +
            "               <div id='existing-comments'></div>" +
            "               <div id='add-comment-form' style='border:1px solid #dee2e6;border-radius:6px;padding:12px;margin-top:10px;'>" +
            "                 <div style='font-size:13px;font-weight:600;margin-bottom:8px;'>Add new comment</div>" +
            "                 <textarea class='form-control' id='new-comment' rows='3' placeholder='Type comment here...'></textarea>" +
            "                 <div style='margin-top:8px;'>" +
            "                   <input type='checkbox' id='chkConfirm'> <label for='chkConfirm' style='font-size:12px;cursor:pointer;margin:0;'>Confirm insert action</label>" +
            "                   &nbsp;&nbsp;<button disabled type='button' id='btn-insert-comment' class='btn btn-sm btn-primary'>INSERT COMMENT</button>" +
            "                 </div>" +
            "               </div>" +
            "        </div>" +
            "      </div>" +
            "    </div>" +
            "  </div>" +
            "";

        // Append editModal to body
        if (!document.getElementById('editModal')) {
            var _editDiv = document.createElement('div');
            _editDiv.innerHTML = `
<div class="modal fade" id="editModal" tabindex="-1" role="dialog" aria-labelledby="editModalLabel" aria-hidden="true">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="editModalLabel">Edit Question and Answer</h5>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div class="modal-body">
                            <form id="editForm">
                                <div class="mb-3">
                                    <label for="editQuestion" class="form-label">Question</label>
                                    <input type="text" readonly class="form-control" id="editQuestion" name="question">
                                </div>
                                <div class="mb-3">
                                    <label for="editAnswer" class="form-label">Answer</label>
                                    <input type="text" class="form-control" id="editAnswer" name="answer">
                                </div>
                                <div class="mb-3">
                                    <label for="editScore" class="form-label">Score</label>
                                    <input type="number" class="form-control" id="editScore" name="score">
                                </div>
                                <input type="hidden" id="editId" name="id">
                            </form>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                            <button type="button" class="btn btn-primary" id="saveChanges">Save changes</button>
                        </div>
                    </div>
                </div>
            </div>
`;
            document.body.appendChild(_editDiv.firstElementChild);
        }

        // Append addModal to body
        if (!document.getElementById('addModal')) {
            var _addDiv = document.createElement('div');
            _addDiv.innerHTML = `
    <div class="modal fade" id="addModal" tabindex="-1" role="dialog" aria-labelledby="addModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="addModalLabel">Add New Question and Answer</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <form id="addForm">
                        <div class="mb-3">
                            <label for="newQuestion" class="form-label">Question</label>
                            <select class="form-control" id="newQuestion" name="question"></select>
                        </div>
                        <div class="mb-3">
                            <label for="newAnswer" class="form-label">Answer</label>
                            <textarea class="form-control" id="newAnswer" name="answer"></textarea>
                        </div>
                        <div class="mb-3">
                            <label for="newScore" class="form-label">Score</label>
                            <input type="number" class="form-control" id="newScore" name="score" value="1">
                        </div>

                        <div class="mb-3">
                            <label for="newScore">Do you need a new type of question added?</label>
                            <br />Please send an email to <a href="mailto:Madrie@experi.co.za?subject=Add new question type"><img src="/img/tabler/mail.svg" style="height: 14px; width: 14px;" alt="" /> Madrie@experi.co.za</a> and provide the question type to be added. The question type should be applicable to all franchisees / tutors, please don't request a question that is only specific to yourself.
                        </div>
                        
                    </form>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                    <button type="button" class="btn btn-primary" id="saveNewItem">Save changes</button>
                </div>
            </div>
        </div>
    </div>
`;
            document.body.appendChild(_addDiv.firstElementChild);
        }

        // Bind comment form handlers
        var _self = this;
        var _chk = _self.querySelector('#chkConfirm');
        var _btn = _self.querySelector('#btn-insert-comment');
        if (_chk) {
            _chk.addEventListener('click', function() {
                if (_btn) _btn.disabled = !this.checked;
            });
        }
        if (_btn) {
            _btn.addEventListener('click', function() {
                var _txt = _self.querySelector('#new-comment');
                var msg = _txt ? _txt.value : '';
                if (!msg.trim()) return;
                $.post(c_websiteurl + 'app.php/learners/insertcomment/', {
                    message: msg, parent_id: c_id
                }, function() {
                    if (_txt) _txt.value = '';
                    if (_chk) _chk.checked = false;
                    if (_btn) _btn.disabled = true;
                    loadExistingComments(c_id);
                }).fail(function() { alert('Insert comment failed'); });
            });
        }

        function fetchQuestions() {
            var requestURL = c_websiteurl + 'app.php/questions/json/';
            $.get(requestURL, function(data) {
                var questions = data;
                var select = document.getElementById('newQuestion');
                questions.forEach(function(question) {
                    var option = document.createElement('option');
                    option.value = question.id;
                    option.text = question.question_text;
                    select.appendChild(option);
                });
            }).fail(function() {
                console.error("Failed to fetch questions.");
            });
        }

        function html_entity_decode(str) {
            var textArea = document.createElement('textarea');
            textArea.innerHTML = str;
            return textArea.value;
        }

        function updateQAScore() {
            $.get(c_websiteurl + 'app.php/questionsanswers/getlearnerscore/?id=' + c_id)
                .done(function (data) {
                    var json = safeParse(data);
                    $('#qa_score').html(json.total_score);
                });
        }

        function loadLearnerCommentsComponent(id) {
            $("#right-panel-container").html('');
            var element = document.createElement("learner-comments");
            element.id = id;
            $("#right-panel-container").html(element);
        }

        function commentsBlock(json) {
            loadExistingComments(json.id);
        }

        function loadExistingComments(learner_id) {
            var _existingEl = _self.querySelector('#existing-comments');
            if (_existingEl) _existingEl.innerHTML = '';
            $.get(c_websiteurl + 'app.php/learners/comments/', { id: learner_id })
                .done(function(data) {
                    var comments = safeParse(data);
                    if (!Array.isArray(comments)) return;
                    var _scoreEl = _self.querySelector('#comments_score');
                    if (_scoreEl) _scoreEl.textContent = comments.length;
                    comments.forEach(function(comment) {
                        var html = '<div style="border:1px solid #dee2e6;border-radius:6px;padding:10px;margin-bottom:8px;">'
                            + '<div style="font-size:11px;color:#6b7280;margin-bottom:6px;">'
                            + '<strong>' + comment.user_fullname + '</strong> &middot; ' + comment.date_formatted + ' (' + comment.time_ago + ')'
                            + ' <button class="btn btn-sm btn-danger btn-delete-comment" data-id="' + comment.id + '" style="float:right;padding:1px 6px;font-size:11px;line-height:1.4;"><img src="/img/tabler/trash.svg" style="height:12px;width:12px;filter:invert(1);vertical-align:-1px;"> Delete</button>'
                            + '</div>'
                            + '<textarea class="form-control" id="existing-comment-' + comment.id + '" rows="2">' + comment.value + '</textarea>'
                            + '<div style="margin-top:4px;font-size:12px;">'
                            + '<input type="checkbox" value="' + comment.id + '" class="checkbox-confirm-update"> <label style="font-size:11px;">Confirm update</label>'
                            + ' <button disabled type="button" id="btn-update-comment-' + comment.id + '" data-id="' + comment.id + '" class="btn btn-sm btn-primary btn-update-comment">UPDATE COMMENT</button>'
                            + '</div></div>';
                        _self.querySelector('#existing-comments').insertAdjacentHTML('beforeend', html);
                    });
                    _self.querySelectorAll('.btn-delete-comment').forEach(function(btn) {
                        btn.addEventListener('click', function(e) {
                            e.preventDefault();
                            if (!confirm('Delete this comment?')) return;
                            $.post(c_websiteurl + 'app.php/learners/deletecomment/', { id: this.dataset.id }, function() {
                                loadExistingComments(learner_id);
                            });
                        });
                    });
                    _self.querySelectorAll('.checkbox-confirm-update').forEach(function(chk) {
                        chk.addEventListener('click', function() {
                            var updateBtn = _self.querySelector('#btn-update-comment-' + this.value);
                            if (updateBtn) updateBtn.disabled = !this.checked;
                        });
                    });
                    _self.querySelectorAll('.btn-update-comment').forEach(function(btn) {
                        btn.addEventListener('click', function(e) {
                            e.preventDefault();
                            var id = this.dataset.id;
                            var txt = _self.querySelector('#existing-comment-' + id);
                            $.post(c_websiteurl + 'app.php/learners/updatecomment/', {
                                message: txt ? txt.value : '', id: id, parent_id: learner_id
                            }, function() { loadExistingComments(learner_id); });
                        });
                    });
                })
                .fail(function() { console.error('[comments] AJAX failed'); });
        }

        if (c_id > 0) {
            var qasTable = $('#qasTable').DataTable({
                dom: 'frtip', pageLength: 50, processing: true, serverSide: true, sort: false,
                ajax: { url: c_websiteurl + "app.php/questionsanswers/apiIndex/?id=" + c_id, type: "GET" },
                columns: [
                    { data: 'question' }, { data: 'answer' },
                    { data: 'score', createdCell: function(td, v) {
                        $(td).css({ 'font-weight': 'bold', 'text-align': 'center', 'font-size': '13px' });
                    }},
                    { data: null, width: '32px', render: function(d,t,row) { return `<button class='btn btn-sm btn-edit-qa' data-id='${row.id}' style='padding:2px 4px'><img src='/img/tabler/edit.svg' style='height:14px;width:14px' /></button>`; }},
                    { data: null, width: '32px', render: function(d,t,row) { return `<button class='btn btn-sm btn-delete-qa' data-id='${row.id}' style='padding:2px 4px'><img src='/img/tabler/trash.svg' style='height:14px;width:14px' /></button>`; }}
                ],
                createdRow: function(row, data) {
                    if (data.score > 0) {
                        $(row).find('td').each(function() {
                            this.style.setProperty('--tblr-table-striped-bg', '#fef3c7');
                            this.style.setProperty('--tblr-table-bg-type', '#fef3c7');
                            this.style.setProperty('background-color', '#fef3c7', 'important');
                            this.style.setProperty('border-top', '1px solid #fdba74', 'important');
                        });
                    }
                }
            });
            $('#qas-container').show();
            updateQAScore();

            $('#qasTable').on('click', '.btn-delete-qa', function() {
                if (!confirm('Delete?')) return;
                $.post(c_websiteurl + 'app.php/questionsanswers/deleteApi/', { id: $(this).data('id') }, function() { qasTable.ajax.reload(); updateQAScore(); });
            });
            $('#qasTable').on('click', '.btn-edit-qa', function() {
                $.get(c_websiteurl + 'app.php/questionsanswers/getById/', { id: $(this).data('id') }, function(data) {
                    var j = safeParse(data);
                    $('#editQuestion').val(j.question.question_text); $('#editAnswer').val(j.answer); $('#editScore').val(j.score); $('#editId').val(j.id);
                    fBsModal('editModal', 'show');
                });
            });
            $('#saveChanges').off('click').on('click', function() {
                fBsModal('editModal', 'hide');
                $.post(c_websiteurl + 'app.php/questionsanswers/updateapi/', { id: $('#editId').val(), answer: $('#editAnswer').val(), score: $('#editScore').val() }, function() {
                    qasTable.ajax.reload(); updateQAScore();
                });
            });
            document.getElementById('saveNewItem').addEventListener('click', function(e) {
                e.stopPropagation();
                fBsModal('addModal', 'hide');
                $.post(c_websiteurl + 'app.php/questionsanswers/store/', {
                    question_id: document.getElementById('newQuestion').value,
                    answer: document.getElementById('newAnswer').value,
                    score: document.getElementById('newScore').value,
                    learner_id: c_id
                }, function() {
                    if (qasTable) qasTable.ajax.reload(); updateQAScore();
                }).fail(function() { console.error('Store QA failed.'); });
            });
            fetchQuestions();

            // Bind Add New Item button click handler
            var addBtn = _self.querySelector('#btn-add-new-qa');
            if (addBtn) addBtn.addEventListener('click', function(e) {
                e.preventDefault();
                e.stopPropagation();
                fBsModal('addModal', 'show');
            });

            commentsBlock({id: c_id});
        }
    }
}

window.customElements.define('learner-comments', LearnerComments);
